import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import Modal from '../../components/Modal'
import { Checkbox } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import Table from '../../components/Table'
import { getParallelsForGroupNutrition } from '../../actions/directoryCanteen'
import { createLogSettingTable, getLogSettingTablesColumns, updateLogSettingTable } from '../../actions/settingLogging'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.scss'

export default function SettingLoggingModal({ data, closeModal, height, width }) {
  const dispatch = useDispatch()
  const { logSettingTablesColumns, logSettingTables } = useSelector(state => state.log_setting)

  const addMode = !data?.tablename

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const [all, setAll] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const handleCreate = async () => {
    const payload = {
      ...values,
      life_time: 0,
      tablename: selectedItem?.table_name,
      description: values?.description?.join(';'),
      fields: values?.fields?.join(';')
    }
    dispatch(createLogSettingTable(payload))
    closeModal()
  }

  const handleUpdate = async (values) => {
    const payload = {
      ...values,
      description: values?.description?.join(';'),
      fields: values?.fields?.join(';')
    }
    dispatch(updateLogSettingTable(payload))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    setFieldValue,
    setValues,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  useEffect(() => {
    dispatch(getParallelsForGroupNutrition())
    selectedItem && dispatch(getLogSettingTablesColumns(selectedItem?.table_name))
  }, [selectedItem])

  useEffect(() => {
    const selectAll = logSettingTablesColumns?.map(el => el.column_name)
    all ? setFieldValue('description', selectAll) : setFieldValue('description', [])
    all ? setFieldValue('fields', selectAll) : setFieldValue('fields', [])
  }, [all])

  useEffect(() => {
    const selectesdItemFields = Array.isArray(values?.description) ? values?.description : (values?.description?.toLowerCase().split(';'))
    const selectesdItemFields2 = Array.isArray(values?.fields) ? values?.fields : (values?.fields?.toLowerCase().split(';'))
    const selectAll = logSettingTablesColumns?.map(el => el.column_name)
    const keyfieldname = logSettingTables && logSettingTablesColumns?.find(el => el.is_primary_key === true)?.column_name
    !addMode ? !all ? setFieldValue('description', selectesdItemFields) : setFieldValue('description', selectAll) : setFieldValue('description', [])
    !addMode ? !all ? setFieldValue('fields', selectesdItemFields2) : setFieldValue('fields', selectAll) : setFieldValue('fields', [])
    addMode && setFieldValue('keyfieldname', keyfieldname)
  }, [logSettingTablesColumns])

  const handleChangeCheck = (e) => {
    if (values?.[e.target.name]?.find(el => el === e.target.value)) {
      setValues(prevValues => ({
        ...prevValues,
        [e.target.name]: values?.[e.target.name].filter((el, i) => values?.[e.target.name].indexOf(e.target.value) !== i)
      }))
    } else {
      setValues(prevValues => ({
        ...prevValues,
        [e.target.name]: prevValues[e.target.name] ? [...prevValues[e.target.name], e.target.value] : [e.target.value]
      }))
    }
  }

  const handleSelect = (item) => {
    setSelectedItem(item)
  }

  const renderLi = (item) => {
    const { table_name, f_descript } = item
    return (
      <tr key={table_name} className={!addMode ? styles.disabled : undefined}>
        <td
          onClick={() => handleSelect(item)}
          style={{ backgroundColor: selectedItem?.f_descript === f_descript ? '#3689FF' : '' }}
        >
          {table_name}
        </td>
      </tr>
    )
  }

  return (
    <Modal
      open={!!data}
      height={height}
      width={width}
      center
      onClose={handleClose}
      closeOnOverlayClick={true}
      closeOnEsc={true}
    >
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <div className={styles.modalLocal}>
              <div className={styles.tabWrapper}>
                <Table className={styles.table}>
                  <thead>
                    <tr>
                      <th>Перечень таблиц</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logSettingTables?.map(renderLi)}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className={styles.inputsColumn}>
              <div className={styles.inputsRow}>
                <h5>Ключевое поле
                  <span style={{ marginLeft: '20px', fontSize: '15px', backgroundColor: '#78affc', borderRadius: '5px', padding: '5px 2px' }}>
                    {values?.keyfieldname}
                  </span>
                </h5>
              </div>
              <div className={styles.inputsRow}>
                {Array.isArray(values?.description) && (
                  <>
                    <div className={styles.inputsColumn}>
                      <p>Атрибуты описания</p>
                      {logSettingTablesColumns?.map(par => {
                        const che = values?.description.find(el => par.column_name === el)
                        return (
                          <Checkbox
                            key={par.column_name}
                            label={par.column_name}
                            checked={!!che}
                            value={par.column_name}
                            onChange={handleChangeCheck}
                            name='description'
                          />
                        )
                      })}
                    </div>
                    <div className={styles.inputsColumn}>
                      <p>Атрибуты журнализации</p>
                      {logSettingTablesColumns?.map(par => {
                        const che = values?.fields.find(el => par.column_name === el)
                        return (
                          <Checkbox
                            key={par.column_name}
                            label={par.column_name}
                            checked={!!che}
                            value={par.column_name}
                            onChange={handleChangeCheck}
                            name='fields'
                          />
                        )
                      })}
                    </div>
                  </>
                )}
              </div>
              <div className={styles.inputsColumn}>
                <Checkbox
                  label='Выбрать все'
                  className={styles.checkboxBottom}
                  checked={all}
                  onClick={() => setAll(!all)}
                  name='allFields'
                />
                <Checkbox
                  label='Включить журнализацию'
                  className={styles.checkboxBottom}
                  checked={!!values.active}
                  value={values.active}
                  onChange={() => setFieldValue('active', +!values.active)}
                  name='active'
                />
              </div>
              {!values?.fields?.length && !values?.description?.length && (
                <h3 style={{ color: 'red' }}>Необходимо указать Атрибуты описания и Атрибуты журнализации</h3>
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} correctBody={values?.fields?.length && values?.description?.length} settingLogging />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
